<template>
  <div id="container" class="sbook_st_upload">
    <!-- Location START -->
    <div class="location_wrap">
      <div class="location">
        <span>{{ $t('views.selfbook.selfbookupload.9793') }}</span>
        <span class="svg_next">></span>
        <div class="current">
          <div class="select_area">
            <div class="select_item">
              <button type="button" class="select_option">
                <span class="txt">{{
                  $t('views.selfbook.selfbookupload.906')
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Location END -->

    <!-- 도서 기본 정보 -->
    <div class="section full">
      <div class="inner" @drop.prevent="addFile" @dragover.prevent>
        <div class="upload_book">
          <div class="upload_img"></div>
          <p>{{ $t('views.selfbook.selfbookupload.8767') }}</p>
          <div class="btn_wrap tac">
            <form>
              <input
                ref="fileInput"
                data-max-size="55000000"
                accept="application/pdf"
                type="file"
                hidden
                @change="addFile"
              />
              <button type="button" class="box_btn upload" @click="uploadFile">
                <span class="an_t"
                  ><a>{{ $t('views.selfbook.selfbookupload.9784') }}</a></span
                >
              </button>
            </form>
          </div>
          <p>{{ $t('views.selfbook.selfbookupload.pdfsize') }}</p>
          <div class="progress_bar">
            <!-- TODO: @Stan Use this style binding to change the width of the bar -->
            <div class="current" :style="currentPercent"></div>
            <p class="uploading">
              {{ $t('views.selfbook.selfbookupload.uploading') }}
              <span>{{ `${percentUploaded}%` }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 도서 세부 정보 -->
    <div class="section fill">
      <div class="inner line">
        <div class="detail_book_introduce">
          <div class="box">
            <div class="box_inner line">
              <dl class="meta_specific sbook">
                <dt>{{ $t('views.selfbook.selfbookupload.7506') }}</dt>
                <dd>{{ fileName }}</dd>
                <dt>{{ $t('views.selfbook.selfbookupload.1661') }}</dt>
                <dd>{{ fileSize }}MB</dd>
                <dt>{{ $t('views.selfbook.selfbookupload.1981') }}</dt>
                <dd>
                  {{ filePageCount
                  }}{{ $t('views.selfbook.selfbookupload.pagecount') }}
                </dd>
              </dl>
            </div>
          </div>
          <div class="btn_wrap tac">
            <button
              type="summit"
              class="box_btn"
              :class="{ dull: !isValid }"
              @click="registerPdf()"
            >
              <span class="an_t"><a>저장</a></span>
            </button>
            <!--
            <button type="summit" class="box_btn" :class="{ dull: !isValid }">
              <span class="an_t"
                ><a href="javascript:void(0)">{{ $t('views.selfbook.selfbookupload.486') }}</a></span
              >
            </button>
            -->
          </div>
        </div>
      </div>
    </div>

    <!-- 헬프 데스크 START -->
    <HelpDesk />
    <!-- 헬프 데스크 END -->

    <!-- ERROR MODAL -->
    <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="toggleErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleErrorModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner">
              <p>
                {{ errorMessage }}
              </p>
              <div class="btnWrap">
                <button class="box_btn w-full" @click="toggleErrorModal">
                  <span class="an_t">{{
                    $t('library.deletemodal.close')
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import HelpDesk from '@/components/common/HelpDesk.vue'

// import pdfjs from 'pdfjs-dist'
// import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
/*
  Loading workers is required for pdfjs. See: 
  https://github.com/wojtekmaj/react-pdf/issues/321#issuecomment-650030702
*/
// pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker

import { AUTH_SIGNED_URL_GET } from '@/store/types'
import axios from 'axios'

import { mapGetters } from 'vuex'

export default {
  name: 'SelfbookUpload',
  components: {
    HelpDesk
  },
  data() {
    return {
      percentUploaded: 0,
      file: null,
      pdf: null,
      errorMessage: '',
      showErrorModal: false
    }
  },
  computed: {
    ...mapGetters(['getAuthSignedUrl']),
    // Use this to show
    currentPercent: function () {
      return {
        width: `${this.percentUploaded}%`
      }
    },
    fileName() {
      if (!this.file) return ''
      return this.file.name
    },
    fileSize() {
      if (!this.file) return 0
      return (this.file.size / (1024 * 1024)).toFixed(2)
    },
    filePageCount() {
      if (!this.pdf) return 0
      return this.pdf.numPages
    },
    isValid() {
      if (this.file && this.percentUploaded === 100) {
        return true
      }
      return false
    }
  },
  mounted() {
    if (window.location.host == 'khu.ealice.com') {
      alert('현재 준비중인 서비스입니다.')
      this.$router.push({ name: 'store' })
    }
  },
  methods: {
    toggleErrorModal(errorMessage) {
      if (errorMessage) {
        this.errorMessage = errorMessage
      }
      this.showErrorModal = !this.showErrorModal
    },
    uploadFile() {
      this.$refs.fileInput.click()
    },
    async uploadToS3() {
      const reader = new FileReader()
      const that = this

      // reader.onload = (e) => {
      //   const typedarray = new Uint8Array(e.target.result)

      //   pdfjs.getDocument(typedarray).promise.then((pdf) => {
      //     that.pdf = pdf
      //   })
      // }
      reader.readAsArrayBuffer(this.file)

      try {
        await this.$store.dispatch(AUTH_SIGNED_URL_GET, {
          fileSize: this.file.size,
          fileName: this.file.name,
          type: 'SB'
        })

        delete axios.defaults.headers.common['Authorization']

        const config = {
          headers: { 'Content-Type': this.file.type },
          onUploadProgress: (event) => {
            that.percentUploaded = Math.round(
              (event.loaded * 100) / event.total
            )
          }
        }

        await axios.put(this.getAuthSignedUrl, this.file, config)

        this.url = this.getAuthSignedUrl.split('?')[0]
      } catch (err) {
        if (err.response) {
          this.toggleErrorModal(
            `[${err.response.data.errorState.code}] ${err.response.data.errorState.message}`
          )
        }
      }
    },
    addFile(e) {
      let files = e.target.files ? e.target.files : e.dataTransfer.files
      if (!files) return
      this.file = files[0]

      /* 
        This is required to get number of pages of pdf file 
        that the user is uploading. See doc: https://github.com/mozilla/pdfjs-dist
      */
      this.uploadToS3()
    },
    registerPdf() {
      const contentInfo = {
        url: this.url,
        fileSize: this.file.size,
        pages: this.filePageCount
      }

      this.$router.push({
        name: 'selfbook_create',
        params: {
          contentInfo
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .sbook_st_upload .detail_book_introduce .meta_specific dd:nth-of-type(2) {
    width: 65px;
  }

  .sbook_st_upload .detail_book_introduce .meta_specific dd:nth-of-type(3) {
    width: 45px;
  }
}
</style>
